import { useEffect, useState } from "react";
import axios from "axios";
import { Sparkles, Ticket, Tag } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminHome() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem("admin_session_token");
    axios
      .get(`${API}/admin/stats`, {
        withCredentials: true,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .then((r) => setStats(r.data))
      .catch(() => setStats({ error: true }));
  }, []);

  return (
    <div data-testid="admin-home">
      <p className="eyebrow">Overview</p>
      <h1>Welcome back.</h1>
      <p className="muted">Quick snapshot of today's activity across Zorba's online channels.</p>
      <div className="stat-grid">
        <StatCard icon={Sparkles} label="Enquiries" value={stats?.enquiries_total ?? "—"} />
        <StatCard icon={Tag} label="Active offers" value={stats?.active_offers ?? "—"} />
        <StatCard icon={Ticket} label="Active vouchers" value={stats?.vouchers?.ACTIVE?.count ?? 0} />
        <StatCard icon={Ticket} label="Redeemed" value={stats?.vouchers?.REDEEMED?.count ?? 0} />
      </div>
    </div>
  );
}

function StatCard({ icon: Icon, label, value }) {
  return (
    <div className="stat-card">
      <Icon size={18} />
      <span className="stat-label">{label}</span>
      <strong>{value}</strong>
    </div>
  );
}
